module.exports = __webpack_public_path__ + "icons/original/small/small-f2.1214cc29cc865a50e028b884cf34173d.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f2.png
// module id = xFS2
// module chunks = app